import { GridRequest } from "projects/app-core/src/models/gridRequest";

export interface ForumRegistrationGridRequest
    extends GridRequest<
        ForumRegistrationSort,
        ForumRegistrationFilter,
        ForumRegistrationSearch,
        ForumRegistrationDateFilter
    > { }
export enum ForumRegistrationSort {
    REGISTRATION_DATE = "REGISTRATION_DATE",
}
export enum ForumRegistrationFilter {
    FORUM_ID = "FORUM_ID",
    PAYMENT_TYPE = "PAYMENT_TYPE",
    HIDE_TEST_REGISTRATION = "HIDE_TEST_REGISTRATION",
}
export enum ForumRegistrationSearch {
    USER_EMAIL = "USER_EMAIL",
}
export enum ForumRegistrationDateFilter {
    REGISTRATION_DATE = "REGISTRATION_DATE",
}
